import { ComponentType } from "react";
import { LucideProps } from "lucide-react";

interface EmptyStateProps {
  icon: ComponentType<LucideProps>;
  title?: string;
  subtitle?: string;
}

export function EmptyState({ icon: Icon, title, subtitle }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-10">
      <Icon className="text-content-disabled mb-3 size-8" strokeWidth={1.5} />
      <div className="flex flex-col items-center justify-center gap-1">
        {title && (
          <p className="text-sm font-semibold text-[#6B7280]">{title}</p>
        )}
        {subtitle && (
          <p className="text-action-disabled-content text-[13px]">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
